import type { TFunction } from "i18next";

import createDockPageRegistry, { type DockPageMeta } from "~/components/dock/dockPageRegistry";

const createReportsPages = (t: TFunction<"common">): DockPageMeta[] => [
	{
		id: "reports",
		path: "/reports",
		title: t("dock.pages.reports.section")
	}
];

const createReportsDockPageRegistry = (t: TFunction<"common">) =>
	createDockPageRegistry(createReportsPages(t), "reports");

export default createReportsDockPageRegistry;
